webpackJsonp([4],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getTranslations = __webpack_require__(57);
	
	var _getTranslations2 = _interopRequireDefault(_getTranslations);
	
	var _acura = __webpack_require__(67);
	
	var _acura2 = _interopRequireDefault(_acura);
	
	var _cms = __webpack_require__(80);
	
	var _parseLayoutCmsData = __webpack_require__(92);
	
	var _parseLayoutCmsData2 = _interopRequireDefault(_parseLayoutCmsData);
	
	var _readConfigData = __webpack_require__(64);
	
	var _readConfigData2 = _interopRequireDefault(_readConfigData);
	
	var _desktop = __webpack_require__(303);
	
	var _geo = __webpack_require__(58);
	
	var _geo2 = _interopRequireDefault(_geo);
	
	var _desktop2 = __webpack_require__(558);
	
	var _desktop3 = _interopRequireDefault(_desktop2);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cmsData = (0, _cms.parseData)(window.__pageContentData || {}); /**
	                                                                    * Acura.ca/old (Desktop)
	                                                                    *
	                                                                    * Entry point to the legacy Acura.ca desktop web client
	                                                                    *
	                                                                    */
	
	var layoutCmsData = (0, _parseLayoutCmsData2.default)(cmsData);
	var config = (0, _readConfigData2.default)('acura-config');
	
	var app = (0, _lodash.assign)({}, {
	  theme: _acura2.default,
	  isDesktop: true,
	  isMobile: false,
	  isResponsive: false,
	  modelsNavList: [],
	  env: ("production"),
	  version: ("3.4.5"),
	  outerContainerId: 'hui-layout-container',
	  pageWrapId: 'hui-content-container',
	  menuPanelWidth: 390,
	  vehiclePanelWidth: 780,
	  firstPanelId: 'contentMenu',
	  translations: (0, _getTranslations2.default)(config.language)
	}, config, layoutCmsData);
	
	(0, _desktop.renderNavs)(app);
	(0, _desktop.renderFooter)(app);
	
	_desktop3.default.init(app);
	_geo2.default.init(app);

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(252);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(8);
	
	var _dispatcher = __webpack_require__(136);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _constants = __webpack_require__(113);
	
	var _associations = __webpack_require__(358);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleDealerLocatorToggle = function handleDealerLocatorToggle(provinceCode, postalCode) {
	  var $dlPostalCodeInput = (0, _jquery2.default)('.dealer-locator .input-post-code');
	  var $dlPostalCodeGoBtn = (0, _jquery2.default)('.find-dealers-by-postal');
	  //load results for postal code if postal code is present
	  if (postalCode !== '') {
	    if ($dlPostalCodeInput.length === 0) return;
	    $dlPostalCodeInput.val('' + postalCode).trigger('keyup');
	    $dlPostalCodeInput.siblings('.input-btn').addClass('alt-color');
	    $dlPostalCodeGoBtn.trigger('click');
	  }
	  //if no postal code, load provinces
	  else {
	      $dlPostalCodeInput.val('').trigger('keyup');
	      var $dlProvinceDropdown = (0, _jquery2.default)('.selectboxit');
	      if ($dlProvinceDropdown.length > 0) {
	        window.selectDealerLocatorProvince(provinceCode);
	      } else {
	        (0, _jquery2.default)('.locate-dealer-dropdown').val('' + provinceCode);
	      }
	      if (provinceCode === _constants.DEFAULT_PROVINCE_CODE) {
	        (0, _jquery2.default)('.dealer-results').hide();
	        var $titleHeader = (0, _jquery2.default)('.dealers.page-header-title');
	        $titleHeader.text($titleHeader.data('origTitle'));
	      }
	    }
	};
	
	var migrationsDesktop = {
	  init: function init(config) {
	    var _this = this;
	
	    _dispatcher2.default.on(_constants.EVENTS.ProvinceSelected, function (_ref) {
	      var province = _ref.province,
	          code = _ref.code,
	          postalCode = _ref.postalCode;
	
	      _this.updatePaymentCalculator(code);
	      _this.updateSpecialOffers(code, postalCode, config);
	      _this.updateDealersLocator(code, postalCode);
	      _this.updateTireWizard(code);
	    });
	  },
	  getAssociations: function getAssociations(config) {
	    //TODO: need to get associations fro API
	    var fallbackAssociations = config.language === 'en' ? _associations.associationsFallbackData : _associations.associationsFalbackData_fr;
	    return fallbackAssociations;
	  },
	  updatePaymentCalculator: function updatePaymentCalculator(province) {
	    var $financeCalculator = (0, _jquery2.default)('#finance_calculator');
	
	    if ((0, _jquery2.default)('#province', $financeCalculator).length > 0) {
	      var provinceCode = province;
	      if (['', 'NT', 'NU'].indexOf(province) >= 0) {
	        provinceCode = 'ON';
	      }
	      if (window.provinceDropdownChange) {
	        window.provinceDropdownChange(provinceCode);
	      }
	    }
	  },
	  updateSpecialOffers: function updateSpecialOffers(provinceCode, postalCode, config) {
	    if ((0, _jquery2.default)('#special-offers-page .no-association').length > 0) {
	      if (provinceCode === _constants.DEFAULT_PROVINCE_CODE) return;
	      var associations = this.getAssociations(config);
	      var association = (0, _lodash.find)(associations, { Province: { Abbreviation: provinceCode } });
	      if (association) {
	        var url = association.Url;
	        if (window.location.pathname.indexOf(url) < 0) window.location.href = url;
	      }
	    } else if ((0, _jquery2.default)('#special-offers-page').length > 0) {
	      handleDealerLocatorToggle(provinceCode, postalCode);
	    }
	  },
	  updateDealersLocator: function updateDealersLocator(provinceCode, postalCode) {
	    //dealer locator
	    if ((0, _jquery2.default)('#dealer-locator-page').length > 0) {
	      handleDealerLocatorToggle(provinceCode, postalCode);
	    }
	  },
	  updateTireWizard: function updateTireWizard(provinceCode) {
	    //Tire wizard
	    if ((0, _jquery2.default)('#tire-finder-dealer-collection-primary').length > 0) {
	      if ((0, _jquery2.default)('#tire-finder-dealer-collection-primary').css('display') === 'block') {
	        var provinceItem = (0, _jquery2.default)('.province-selector-form .dropdown_list .province[rel="' + provinceCode + '"]');
	        (0, _jquery2.default)('.dropdown_container.vehicle_box.dealer_region_box').hide();
	        if (provinceItem.length > 0) {
	          (0, _jquery2.default)('.tire-province-selector span').text((0, _jquery2.default)(provinceItem).html());
	          (0, _jquery2.default)('.tire-wizard-search-results').show();
	          if (window.tireSelectionController) {
	            window.tireSelectionController.getDealerCollectionController().bindDealersByRegion(provinceCode);
	          }
	        } else {
	          var title = (0, _jquery2.default)('.tire-province-selector').data('title');
	          (0, _jquery2.default)('.tire-province-selector span').text(title || 'Region');
	          (0, _jquery2.default)('.tire-wizard-search-results').hide();
	        }
	      }
	    }
	  }
	};
	
	exports.default = migrationsDesktop;

/***/ })

});


// WEBPACK FOOTER //
// desktop.js